import { Button, ButtonProps, Text } from "@chakra-ui/react";
import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import { FiClock } from "react-icons/fi";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export interface SetTimeButtonProps extends ButtonProps {
  setTime?: string;
  onSetTime?: () => void;
  timezone?: string;
}

export const SetTimeButton: React.FC<SetTimeButtonProps> = ({
  setTime,
  onSetTime,
  timezone,
  ...buttonProps
}) => (
  <Button
    aria-label="Set Time"
    h={10}
    leftIcon={<FiClock />}
    size="sm"
    variant="outline"
    onClick={onSetTime}
    mr={2}
    {...buttonProps}
  >
    <Text fontSize="sm" color={setTime ? "gray.700" : "gray.400"}>
      {setTime ? dayjs(setTime).tz(timezone).format("hh:mm A") : "Set Time"}
    </Text>
  </Button>
);
